<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20">
      <form v-on:submit.prevent="submitForm">
        <h3 class="mt0">{{getTitleText}}</h3>
        <ul class="breadcrumb">
          <li>
            <router-link :to="{ name: 'ManageGroup'}">{{'My groups'|translate}}</router-link>
          </li>
          <li>{{getTitleText}}</li>
        </ul>
        <div class="row">
          <div class="col-md-8 mb20">
            <label class="mt20">{{'Name'|translate}} <span class="required">(*)</span>:</label>
            <input
              v-model="item.name"
              ref="name"
              required
              :placeholder="'Input name'|translate"
              class="form-control"
            />
            <label class="mt20">Điện thoại:<span class="required">(*)</span></label>
            <MultilePhone v-if="ready"
            :item="item"
            ref="phone"
            :api_url="'/my-groups/checkExistingPhone/'"
            ></MultilePhone>
            <label class="mt20">Mô tả:</label>
            <textarea v-model="item.description" class="form-control"></textarea>

            <div class="mt20" v-if="ready">
              <selectlocation
                :province="item.province_id"
                :district="item.district_id"
                :commune="item.commune_id"
                :p_location="item.location_coord"
                @updateLocation="updateLocation"
              ></selectlocation>
            </div>
            <label class="mt20">{{'Street'|translate}}:</label>
            <input
              type="text"
              required
              v-model="item.street"
              ref="street"
              :placeholder="'Input street'|translate"
              class="form-control"
            />
            <label class="mt20">{{'Type'|translate}}:</label>
            <div>
              <div class="inline-block" v-for="option in type_options" :key="option.key">
              <input type="radio" required :id="option.key"   :value="option.key" v-model="item.type"  >
                <label class="normal" :for="option.key">{{option.label}}</label>
                &nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <input
              type="file"
              id="file-upload"
              ref="file"
              v-on:change="handleFileUpload()"
              style="display:none"
            />
            <div class="feature-image mt10">
              <p>
                <label>Ảnh Đại Diện</label>
              </p>
              <div class="wrapper" v-on:click="triggerFile">
                <img :src="src_image" />
                <span class="upload-icon">
                  <i class="fa fa-camera"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <button class="btn btn-info mt20" type="submit" :disabled="working">
          <i v-if="working" class="fas fa-spinner fa-spin"></i>
          {{getOKText}}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/elements/Loading'
import selectlocation from '@/components/elements/SelectLocation'
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import MultilePhone from '@/components/elements/MultilePhone'
// import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: 'FormGroup',
  components: {
    Loading,
    selectlocation,
    MyHeader,
    MultilePhone
  },
  computed: {
    getTitleText () {
      if (this.item.id) {
        return this.$t('Update group')
      } else {
        return this.$t('Add group')
      }
    },
    getOKText () {
      if (this.item.id) {
        return this.$t('Update')
      } else {
        return this.$t('Add')
      }
    }
  },
  data () {
    let dateFormat = 'DD/MM/YYYY'
    return {
      ready: false,
      working: false,
      type_options: [
        {
          key: '0',
          label: 'Hợp tác xã'
        },
        {
          key: '1',
          label: 'Tổ hợp tác'
        },
        {
          key: '2',
          label: 'Nhóm'
        }
      ],
      src_image: '/static/images/no-photo.jpg',
      all_products: [],
      selectedFile: false,
      dateFormat: dateFormat,
      config: {
        format: dateFormat,
        locale: 'vi',
        maxDate: new Date()
      },
      item: {}
    }
  },
  created () {
    // clone from original params
  },
  methods: {
    defaultValue () {
      this.src_image = '/static/images/no-photo.jpg'
      return {
        name: '',
        phone: '',
        description: '',
        type: 0,
        feature_image_id: '',
        province_id: '',
        district_id: '',
        commune_id: ''
      }
    },
    updateLocation (data) {
      for (let key in data) {
        this.item[key] = data[key]
      }
      console.log('this.item', this.item)
    },
    init () {
      this.src_image = '/static/images/no-photo.jpg'
      this.selectedFile = false

      if (this.item.id) {
        // console.log('this.item',this.item)
        if (this.item.feature_image) {
          this.src_image = this.item.feature_image.thumb_path
        }
      } else {
        this.item = this.defaultValue()
      }
      this.ready = true
      //   for (let key in this.searchparams) {
      //     this.search_params[key] = this.searchparams[key]
      //   }
    },
    submitForm () {
      let data = JSON.parse(JSON.stringify(this.item))

      let phones = this.$refs.phone.getPhones()

      if (phones.length === 0) {
        return this.$alertify.alertWithTitle(
          this.$t('Confirm'),
          'Số phone là bắt buộc ')
      }
      data.phone = phones.join(',')

      let request
      if (this.item.id) {
        request = Utils.requestV2(this, true).put(`/my-groups/`, data)
      } else {
        request = Utils.requestV2(this, true).post(
          `/my-groups/`,
          data
        )
      }
      this.working = true
      request
        .then(response => {
          let data = response.data
          console.log('data', data)

          this.logicFinish()
          this.working = false
        })
        .catch(error => {
          // this.working = false;
          Utils.showErrorMessage(this, error.response)
          this.working = false
        }).finally(() => {

        })
    },

    triggerFile () {
      this.$refs.file.click()
    },
    logicFinish () {
      if (this.item.id) {
        this.$alertify.success(this.$t('Your group is updated'))
      } else {
        this.$alertify.success(this.$t('Your group is added'))
        this.item = this.defaultValue()
        this.ready = false
        setTimeout(() => {
          this.ready = true
        }, 100)
      }
      this.working = false
    },
    uploadFile () {
      let formData = new FormData()
      const files = document.querySelector('[type=file]').files
      formData.append('file', files[0])
      let headers = {
        'Content-Type': 'multipart/form-data'
      }
      Utils.requestV2(this, true)
        .post('/upload', formData, { headers: headers })
        .then(response => {
          console.log('response', response)
          this.item.feature_image_id = response.data.id
        })
        .catch(function (e) {
          console.log(e)
          console.log('FAILURE!!')
        }).finally(() => {
          this.working = false
        })
    },
    handleFileUpload () {
      let file = this.$refs.file.files[0]
      if (file.size > 3000000) {
        return alert('Ảnh phải có dung lượng nhỏ hơn 3MB')
      }
      var validExtensions = ['jpg', 'png', 'jpeg']
      var reader = new FileReader()
      let _this = this
      reader.onloadend = e => {
        let arr = new Uint8Array(e.target.result).subarray(0, 4)
        let header = ''
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16)
        }

        let mimeType = Utils.mimeType(header)
        if (mimeType === 'unknown') {
          this.selectedFile = false
          return _this.$alertify.alertWithTitle(
            _this.$t('Confirm'),
            _this.$t('Only these file types are accepted') +
              ' : ' +
              validExtensions.join(', ')
          )
        }
        var image = new Image()

        this.selectedFile = true
        var base64Image = new Buffer(e.target.result, 'binary').toString(
          'base64'
        )
        image.src = 'data:image/png;base64,' + base64Image
        image.onload = () => {
          console.log(image.width)
          if (image.width < 600) {
            alert('Ảnh phải có chiều dài tối thiểu là 600px')
            return
          }
          if (image.height < 400) {
            alert('Ảnh phải có chiều rộng tối thiểu là 400px')
            return
          }

          _this.src_image = 'data:image/png;base64,' + base64Image
          this.uploadFile()
        }
        // _this.src_image = "data:image/png;base64," + base64Image;
      }
      reader.readAsArrayBuffer(file)
    }
  },
  mounted () {
    this.group_id = this.$route.params.id

    let wating = []
    if (this.group_id) {
      wating.push(
        Utils.requestV2(this, true).get(
          `/my-groups/${this.group_id}`
        )
      )
    }

    Promise.all(wating).then(values => {
      if (this.group_id) {
        console.log('values', values[0].data)
        this.item = values[0].data
      }
      this.init()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Group/FormGroup.vue